<style lang="scss" scoped>
/deep/ .comp-employee-archive-detail-dialog {
    max-width: 720px;
}
.comp-employee-archive-detail {
    .detail-title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        .name {
            margin-right: 8px;
            font-size: 16px;
            font-weight: bold;
            color: #303133;
        }
    }
    .detail-grid {
        display: flex;
        flex-wrap: wrap;
    }
    .detail-item {
        display: flex;
        width: 50%;
        margin-bottom: 12px;
        font-size: 13px;
        .label {
            flex: none;
            width: 96px;
            color: #909399;
        }
        .value {
            flex: 1;
            color: #303133;
            word-break: break-all;
        }
        &.full {
            width: 100%;
        }
    }
    .attachment-list {
        display: flex;
        flex-wrap: wrap;
    }
    .image-preview-mask {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 3000;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.75);
    }
    .image-preview-img {
        max-width: 90vw;
        max-height: 90vh;
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
    }
    .image-preview-close {
        position: absolute;
        top: 20px;
        right: 24px;
        font-size: 28px;
        color: #fff;
        cursor: pointer;
    }
    .image-preview-nav {
        position: absolute;
        top: 50%;
        padding: 12px;
        font-size: 36px;
        color: #fff;
        cursor: pointer;
        transform: translateY(-50%);
        &.left {
            left: 24px;
        }
        &.right {
            right: 24px;
        }
    }
    .attachment-item {
        width: 88px;
        margin: 0 12px 12px 0;
        text-align: center;
    }
    .attachment-thumb,
    .attachment-file,
    .attachment-error {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 88px;
        height: 88px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
    }
    .attachment-thumb {
        cursor: zoom-in;
    }
    .attachment-file {
        font-size: 28px;
        color: #409eff;
        background: #f5f7fa;
    }
    .attachment-error {
        font-size: 24px;
        color: #c0c4cc;
        background: #f5f7fa;
    }
    .attachment-label {
        display: block;
        margin-top: 4px;
        overflow: hidden;
        font-size: 12px;
        color: #606266;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .empty-tip {
        padding: 30px 0;
        text-align: center;
        color: #909399;
    }
}
</style>

<template>
    <div class="comp-employee-archive-detail">
        <el-dialog title="员工档案详情" custom-class="c-el-dialog comp-employee-archive-detail-dialog"
            :visible.sync="showDialog" :close-on-click-modal="false" :close-on-press-escape="false"
            @close="handleDialogClosed" @closed="handleDialogClosed">
            <div v-loading="loading">
                <template v-if="detail">
                    <div class="detail-title">
                        <span class="name">{{ detail.name }}</span>
                        <el-tag size="small" :type="statusTagType">{{ statusText }}</el-tag>
                    </div>
                    <div class="detail-grid">
                        <div class="detail-item">
                            <span class="label">身份证号</span>
                            <span class="value">{{ detail.idNumber || "-" }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">手机号</span>
                            <span class="value">{{ detail.tel || "-" }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">运营区域</span>
                            <span class="value">{{ detail.operationArea || "-" }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">职位</span>
                            <span class="value">{{ detail.position || "-" }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">用工类型</span>
                            <span class="value">{{ detail.employmentType || "-" }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">职业技能</span>
                            <span class="value">{{ detail.skills || "-" }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">入职日期</span>
                            <span class="value">{{ formatDate(detail.hireDate) }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">最后工作日</span>
                            <span class="value">{{ formatDate(detail.leaveDate) }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">银行卡号</span>
                            <span class="value">{{ detail.bankCardNo || "-" }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">开户行</span>
                            <span class="value">{{ detail.bankName || "-" }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">合同到期</span>
                            <span class="value">{{ formatDate(detail.contractExpireDate) }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">创建时间</span>
                            <span class="value">{{ formatDateTime(detail.creationTime) }}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">更新时间</span>
                            <span class="value">{{ formatDateTime(detail.lastModificationTime) }}</span>
                        </div>
                        <div class="detail-item full">
                            <span class="label">附件</span>
                            <div class="value">
                                <div class="attachment-list" v-if="validAttachments.length">
                                    <div class="attachment-item" v-for="(item, index) in validAttachments"
                                        :key="'att-' + index">
                                        <el-image v-if="isImage(item.url)" class="attachment-thumb"
                                            :src="item.url" fit="cover" @click.native="openPreview(item.url)">
                                            <div slot="error" class="attachment-error">
                                                <i class="el-icon-picture-outline"></i>
                                            </div>
                                        </el-image>
                                        <a v-else class="attachment-file" :href="item.url"
                                            target="_blank" rel="noopener noreferrer">
                                            <i class="el-icon-document"></i>
                                        </a>
                                        <span class="attachment-label" :title="item.label || item.url">
                                            {{ item.label || "附件" }}
                                        </span>
                                    </div>
                                </div>
                                <span v-else>-</span>
                            </div>
                        </div>
                        <div class="detail-item full">
                            <span class="label">备注</span>
                            <span class="value">{{ detail.remark || "-" }}</span>
                        </div>
                    </div>
                </template>
                <div class="empty-tip" v-else-if="!loading">未获取到员工档案。</div>
            </div>
            <span slot="footer">
                <el-button type="primary" size="small" @click="showDialog = false">关闭</el-button>
            </span>
        </el-dialog>

        <div class="image-preview-mask" v-if="previewVisible" @click.self="closePreview">
            <i class="el-icon-close image-preview-close" @click="closePreview"></i>
            <i class="el-icon-arrow-left image-preview-nav left" v-if="previewIndex > 0"
                @click.stop="prevPreview"></i>
            <img class="image-preview-img" :src="previewUrl" @click.stop>
            <i class="el-icon-arrow-right image-preview-nav right"
                v-if="previewIndex < previewUrls.length - 1" @click.stop="nextPreview"></i>
        </div>
    </div>
</template>

<script>
import * as funEmployee from "@/api/employees"
import moment from "moment"

export default {
    name: "compEmployeeArchiveDetail",
    data() {
        return {
            showDialog: false,
            loading: false,
            detail: null,
            previewVisible: false,
            previewUrls: [],
            previewIndex: 0
        }
    },
    computed: {
        statusText() {
            if (!this.detail) return ""
            if (this.detail.status === 1 && this.detail.leaveDate) return "待离职"
            return this.detail.statusDesc
        },
        statusTagType() {
            if (!this.detail || this.detail.status !== 1) return "info"
            return this.detail.leaveDate ? "warning" : "success"
        },
        validAttachments() {
            if (!this.detail || !this.detail.attachments) return []
            return this.detail.attachments.filter(t => t.url)
        },
        imageUrls() {
            return this.validAttachments.filter(t => this.isImage(t.url)).map(t => t.url)
        },
        previewUrl() {
            return this.previewUrls[this.previewIndex] || ""
        }
    },
    methods: {
        open(row) {
            this.closePreview()
            this.detail = null
            this.showDialog = true
            // 弹框自身 ESC 关闭被禁用（避免联动关闭图片预览），这里按预览状态手动处理
            document.removeEventListener("keydown", this.handleDialogKeydown)
            document.addEventListener("keydown", this.handleDialogKeydown)
            this.loading = true
            funEmployee.GetEmployeeArchive({ id: row.id }).then(response => {
                this.detail = response
            }).finally(() => {
                this.loading = false
            })
        },
        handleDialogClosed() {
            document.removeEventListener("keydown", this.handleDialogKeydown)
            this.closePreview()
            this.detail = null
        },
        handleDialogKeydown(e) {
            if (e.keyCode !== 27) return
            if (this.previewVisible) {
                // 图片预览打开时，ESC 只关预览；由预览层监听器处理
                e.stopPropagation()
                return
            }
            e.preventDefault()
            this.showDialog = false
        },
        // 自定义预览层：Element UI 2.13 的图片查看器首次关闭后会移除 ESC 监听且不再注册
        openPreview(url) {
            this.previewUrls = this.imageUrls
            this.previewIndex = Math.max(0, this.previewUrls.indexOf(url))
            this.previewVisible = true
            document.addEventListener("keydown", this.handlePreviewKeydown)
        },
        closePreview() {
            this.previewVisible = false
            this.previewUrls = []
            this.previewIndex = 0
            document.removeEventListener("keydown", this.handlePreviewKeydown)
        },
        handlePreviewKeydown(e) {
            if (e.keyCode === 27) {
                e.preventDefault()
                e.stopPropagation()
                this.closePreview()
            } else if (e.keyCode === 37) {
                this.prevPreview()
            } else if (e.keyCode === 39) {
                this.nextPreview()
            }
        },
        prevPreview() {
            if (this.previewIndex > 0) {
                this.previewIndex--
            }
        },
        nextPreview() {
            if (this.previewIndex < this.previewUrls.length - 1) {
                this.previewIndex++
            }
        },
        isImage(url) {
            return /\.(jpg|jpeg|png|gif|bmp|webp)(\?|#|$)/i.test(url || "")
        },
        formatDate(value) {
            return value ? moment(value).format("YYYY-MM-DD") : "-"
        },
        formatDateTime(value) {
            return value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "-"
        }
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.handlePreviewKeydown)
        document.removeEventListener("keydown", this.handleDialogKeydown)
    }
}
</script>
